import { Option } from '../common/OptionInput';
import Response from "../../../../../assets/images/response.jpg";

export const LinkToResponse = ({ onTypeChange, type }) => {

    return (
        <>
            <Option
                id="emailFriend"
                checked={type}
                onChange={onTypeChange}
                text="Link to a response form (click to preview):"
                value="response"
                name="link"
            />
            {type == "response" &&
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "15px"
                }}>
                    <img
                        src={Response}
                        style={{
                            position: "relative",
                            width: "300px",
                            height: "auto",
                        }}
                    />
                </div>
            }
        </>
    )
}
